import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/Gallery.css';
import { Link } from 'react-router-dom';
// Import your images (replace with actual paths)
import image1 from '../img/DF picture.jpg';
import image2 from '../img/Ethiopia 🇪🇹 (1).jpg';
import image3 from '../img/Ethiopian kids ♡🇪🇹.jpg';
import image4 from '../img/Meron & Kids.jpg';
import image5 from '../img/Sweet little girl.jpg';
import image6 from '../img/founder-2.jpg';
import image7 from '../img/Via Wonder Wombman.jpg';
import image8 from '../img/founder-3.jpg';

// Social icons
import { FaInstagram, FaTwitter, FaFacebook, FaPinterest } from 'react-icons/fa';

const Gallery = () => {
  const galleryImages = [
    { id: 1, src: image1, title: 'Community Outreach', description: 'Helping local communities thrive', tags: ['#community', '#support'] },
    { id: 2, src: image2, title: 'Education Support', description: 'Providing learning resources', tags: ['#education', '#future'] },
    { id: 3, src: image3, title: 'Medical Aid', description: 'Bringing healthcare to those in need', tags: ['#healthcare', '#hope'] },
    { id: 4, src: image4, title: 'Food Distribution', description: 'Fighting hunger in our cities', tags: ['#hungerrelief', '#care'] },
    { id: 5, src: image5, title: 'Shelter Support', description: 'Safe spaces for those without homes', tags: ['#shelter', '#safety'] },
    { id: 6, src: image6, title: 'Disaster Relief', description: 'Emergency response teams in action', tags: ['#emergency', '#response'] },
    { id: 7, src: image7, title: 'Youth Programs', description: 'Empowering the next generation', tags: ['#youth', '#empowerment'] },
    { id: 8, src: image8, title: 'Elderly Care', description: 'Supporting our senior community', tags: ['#eldercare', '#respect'] },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    hover: {
      scale: 1.05,
      transition: {
        duration: 0.3,
      },
    },
  };

  const ctaVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay: 0.5
      }
    }
  };

  const socialVariants = {
    hover: {
      y: -5,
      scale: 1.1,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <div className="gallery-page">
      {/* Decorative background elements */}
      <div className="circle-bg circle-1"></div>
      <div className="circle-bg circle-2"></div>
      <div className="circle-bg circle-3"></div>
      <div className="circle-bg circle-4"></div>
      <div className="zigzag-border"></div>
      
      {/* Floating decorative elements */}
      <motion.div 
        className="floating-element triangle"
        animate={{
          y: [0, 15, 0],
          rotate: [0, 5, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      ></motion.div>
      
      <motion.div 
        className="floating-element square"
        animate={{
          y: [15, 0, 15],
          rotate: [5, 0, 5]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
      ></motion.div>

      <div className="container-fluid px-0">
        {/* Header Section */}
        <motion.div 
          className="header-section text-center py-5"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="container">
            <h1 className="gallery-title">GALLERY</h1>
            <p className="gallery-subtitle">Drive into creativity with our gallery collection</p>
            <div className="title-divider"></div>
            <p className="gallery-tagline">Keeper of the Night</p>
          </div>
        </motion.div>

        {/* Gallery Grid */}
        <motion.div 
          className="row gallery-grid mx-0"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {galleryImages.map((image) => (
            <motion.div 
              key={image.id}
              className="col-md-6 col-lg-3 px-2 mb-4 gallery-item-container"
              variants={itemVariants}
              whileHover="hover"
            >
              <div className="gallery-item">
                <div className="image-container">
                  <img src={image.src} alt={image.title} className="img-fluid gallery-image" />
                  <div className="image-overlay"></div>
                </div>
                <div className="image-caption">
                  <h3>{image.title}</h3>
                  <p>{image.description}</p>
                  <div className="image-tags">
                    {image.tags.map((tag, index) => (
                      <span key={index} className="tag">{tag}</span>
                    ))}
                  </div>
                  <div className="social-share">
                    <motion.a 
                      href="#" 
                      className="social-icon"
                      variants={socialVariants}
                      whileHover="hover"
                    >
                      <FaInstagram />
                    </motion.a>
                    <motion.a 
                      href="#" 
                      className="social-icon"
                      variants={socialVariants}
                      whileHover="hover"
                    >
                      <FaTwitter />
                    </motion.a>
                    <motion.a 
                      href="#" 
                      className="social-icon"
                      variants={socialVariants}
                      whileHover="hover"
                    >
                      <FaFacebook />
                    </motion.a>
                    <motion.a 
                      href="#" 
                      className="social-icon"
                      variants={socialVariants}
                      whileHover="hover"
                    >
                      <FaPinterest />
                    </motion.a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Call to Action - now outside container with full width */}
        <motion.section 
          className="cta-section py-5"
          variants={ctaVariants}
          initial="hidden"
          animate="visible"
        >
          <div className="cta-content">
            <div className="cta-bg-overlay"></div>
            <div className="container position-relative">
              <h2>Join Our Cause</h2>
              <p className="text-white">Your support can make a difference in someone's life</p>
              <motion.button 
                className="btn btn-donate"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 5px 15px rgba(255, 0, 0, 0.4)"
                }}
                whileTap={{ scale: 0.95 }}
              >
                <Link to="/donate-now"className="dc">
                                  
                                  Donate Now
                                
                                  </Link>
               
              </motion.button>
              <div className="cta-socials mt-4">
                <p className="text-white mb-2">Follow us:</p>
                <div className="d-flex justify-content-center">
                  {[FaInstagram, FaTwitter, FaFacebook, FaPinterest].map((Icon, index) => (
                    <motion.a
                      key={index}
                      href="#"
                      className="social-icon mx-3"
                      whileHover={{ y: -5, scale: 1.2 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      <Icon size={24} color="white" />
                    </motion.a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Gallery;